import { Card, Space, Table } from "antd";
import { Container } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";

const DataTable = (props: any) => {
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "type",
      title: "Employee Type",
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
    },
    {
      dataIndex: "email",
      title: "Email",
    },
    {
      dataIndex: "phone",
      title: "Phone",
    },
    {
      dataIndex: "gender",
      title: "Gender",
    },

    {
      dataIndex: "dob",
      title: "Date of Birth",
      render: (dob: any) => (dob ? moment(dob).format("DD/MM/YYYY") : "-"), // Format the date and add fallback for null/undefined
    },
    {
      dataIndex: "hireDate",
      title: "Hire Date",
      render: (hireDate: any) =>
        hireDate ? moment(hireDate).format("DD/MM/YYYY") : "-", // Format the date and add fallback for null/undefined
    },
    {
      dataIndex: "bloodGroup",
      title: "Blood Group",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/Employee/viewuser/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <Container>
      <br />
      <Card>
        <h3>Total {props?.meta?.total_count} Employees</h3>
        <br />
        <Table
          columns={columns}
          dataSource={props?.dataSource}
          pagination={props?.pagination}
        />
      </Card>
    </Container>
  );
};

export default DataTable;
